export default function getCaptchaToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY!, { action: 'submit' })
      .then(resolve)
      .catch(reject);
    });
  })
}
